import {
  Box,
  LinearProgress,
  styled,
  Typography
} from '@mui/material';
import _ from 'lodash';
import React, {
  useEffect,
  useState
} from 'react';

import {
  Document,
  Page
} from 'react-pdf';
import Big from 'big.js';

import { AnnotationTypeName } from 'generated/graphql';



export type PlanViewerProps = {
  buffer: ArrayBuffer | null;
  setBuffer: React.Dispatch<React.SetStateAction<ArrayBuffer | null>>;
  apiFileId: string;
  scale?: number;
  // isLoading?: boolean;
  width: Big;
  annotations: {
    id: string;
    type: {
      id: string;
      name: AnnotationTypeName;
      displayName: string;
    };
    color: string;
    page: {
      pageNumber: number;
      height: number;
      width: number;
    };
    relatedId: string | null;
    points: {
      id: string;
      x: Big;
      y: Big;
    }[];
    width: number;
  }[];
};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanViewerProps) => {


  const refContainerDiv = React.useRef<HTMLDivElement>(null);
  const refCanvasDiv = React.useRef<HTMLCanvasElement>(null);

  const [
    canvas,
    setCanvas
  ] = useState<HTMLCanvasElement | null>(refCanvasDiv.current);

  const [
    scale,
    setScale
  ] = useState(props.annotations[0]
    ? Big(props.annotations[0]?.page?.width ?? 1).div(props.width)
      .toNumber()
    : 1);

  useEffect(() => {
    if (canvas !== refCanvasDiv.current) {
      setCanvas(() => refCanvasDiv.current);
      return () => {};
    } else {
      return () => {};
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    canvas,
    refCanvasDiv.current
  ]);


  const [
    numPages,
    setNumPages
  ] = useState<number>();

  useEffect(() => {
    const tempScale = props.annotations[0]
      ? Big(props.annotations[0]?.page?.width ?? 1).div(props.width)
        .toNumber()
      : 1;
    if (scale !== tempScale) {
      setScale(() => tempScale);
    }
  }, [
    props.annotations,
    props.width,
    scale
  ]);



  React.useEffect(() => {

    const ctx: CanvasRenderingContext2D | undefined | null = canvas?.getContext('2d');


    if (ctx) {

      props.annotations.forEach((annotation, i) => {

        ctx.strokeStyle = annotation.color;
        ctx.fillStyle = annotation.color;
        ctx.lineWidth = Big(annotation.width).div(scale)
          .toNumber();

        ctx.save();



        annotation.points.forEach((point, n) => {
          if (n === 0) {
            ctx.beginPath();
            const tempX = Big(point.x).div(scale);
            const tempY = Big(point.y).div(scale);
            ctx.moveTo(tempX.toNumber(), tempY.plus(annotation.page.pageNumber * annotation.page.height / scale).toNumber());
          } else {
            const x = Big(point?.x).div(scale);
            const y = Big(point?.y).div(scale);

            ctx.lineTo(x.toNumber(), y.plus(annotation.page.pageNumber * (annotation.page.height) / scale).toNumber());
          }
          ctx.stroke();
        });

        ctx.closePath();

      });

      return () => {};
    }
  }, [
    props.scale,
    refCanvasDiv,
    props.annotations,
    canvas,
    props.width,
    scale
  ]);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(() => numPages);
  }

  const canvasHeight = __getCanvasHeight(props.annotations, scale);


  if (props.buffer) {
    return (
      <>
        <Box >
          <ContainerDiv
            sx={{
              zIndex: 0,
              borderRadius: '.5rem'
            }}
            ref={refContainerDiv}
          >
            <Document
              file={props.buffer}
              loading={<Typography variant='h1'>LOADING</Typography>}
              onLoadSuccess={onDocumentLoadSuccess}
            >

              {
                _.times(numPages ? numPages : 0, (i) => (

                  <Page
                    // onDoubleClick={() => {
                    //   if (!params.planApiFileId) {
                    //     navigate(`detail/${props.apiFileId}`);
                    //   }
                    // }}

                    key={`${i}`}
                    pageIndex={i}
                    devicePixelRatio={1}
                    pageNumber={i + 1}

                    width={props.width.toNumber()}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />

                ))
              }
            </Document>
            <CanvasDiv
              id='canvas'
              width={props.width.toNumber()}
              height={canvasHeight}
              sx={{
                pointerEvents: 'none'
              }}
              ref={refCanvasDiv}
            />
          </ContainerDiv>
        </Box>
      </>
    );
  }
  return (
    <Box
      height='100%'
    >

      <LinearProgress
        sx={{
          margin: 'auto'
        }}
      />
    </Box>
  );
};

const ContainerDiv = styled('div')({
  position: 'absolute',
  left: 0,
  top: 0

});


const CanvasDiv = styled('canvas')({
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 10000


});


function __getCanvasHeight(annotations: {
  id: string;
  type: {
    id: string;
    name: AnnotationTypeName;
    displayName: string;
  };
  color: string;
  page: {
    pageNumber: number;
    height: number;
    width: number;
  };
  relatedId: string | null;
  points: {
    id: string;
    x: Big;
    y: Big;
  }[];
  width: number;
}[], scale: number) {
  const page2Annotation = _.uniqBy(annotations, (r) => r.page.pageNumber);
  const size = page2Annotation.reduce((acc, r) => {
    return acc + r.page.height;
  }, 0);

  return size / scale;
}

